// removed by extract-text-webpack-plugin
module.exports = {"xs":"src-components-modules-HeadingBlock-style----size-module---xs---2hJMG","s":"src-components-modules-HeadingBlock-style----size-module---s---2VcR4","m":"src-components-modules-HeadingBlock-style----size-module---m---2kH7E","l":"src-components-modules-HeadingBlock-style----size-module---l---10WUi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/HeadingBlock/style/size.module.css
// module id = 1469
// module chunks = 168707334958949